<template>
  <section class="why-us-section section" id="why-us">
    <div class="container">
      <div class="section-header reveal">
        <span class="label">{{ $store.getters.t('whyUs.subtitle') }}</span>
        <h2>{{ $store.getters.t('whyUs.title') }}</h2>
        <p>{{ $store.getters.t('whyUs.desc') }}</p>
      </div>
      <div class="why-grid reveal">
        <div class="why-card" v-for="(card, i) in $store.getters.t('whyUs.cards')" :key="i">
          <div class="why-icon" :class="'icon-' + (i % 3)">
            <svg v-if="i === 0" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <svg v-else-if="i === 1" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
            <svg v-else-if="i === 2" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
            <svg v-else-if="i === 3" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
            <svg v-else-if="i === 4" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          </div>
          <h3>{{ card.title }}</h3>
          <p>{{ card.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'WhyUsSection' }
</script>

<style scoped>
.why-us-section { background: rgba(10,15,28,.4); }
.why-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.why-card {
  background: linear-gradient(180deg, rgba(30,41,59,.7) 0%, rgba(20,30,50,.9) 100%);
  border: 1px solid rgba(255,255,255,.04);
  border-radius: 18px;
  padding: 38px 28px;
  transition: all .4s cubic-bezier(.4,0,.2,1);
  position: relative;
  overflow: hidden;
}
.why-card::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 18px;
  opacity: 0;
  transition: opacity .4s;
  pointer-events: none;
  box-shadow: inset 0 1px 0 rgba(255,255,255,.06);
}
.why-card:hover {
  transform: translateY(-8px);
  border-color: rgba(255,255,255,.08);
  box-shadow: 0 20px 48px rgba(0,0,0,.3);
}
.why-card:hover::after { opacity: 1; }
.why-icon {
  width: 52px; height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: transform .4s;
}
.why-card:hover .why-icon { transform: scale(1.08); }
.icon-0 { background: linear-gradient(135deg, rgba(59,130,246,.2), rgba(59,130,246,.04)); color: #3b82f6; }
.icon-1 { background: linear-gradient(135deg, rgba(139,92,246,.2), rgba(139,92,246,.04)); color: #8b5cf6; }
.icon-2 { background: linear-gradient(135deg, rgba(16,185,129,.2), rgba(16,185,129,.04)); color: #10b981; }
.why-card h3 {
  font-size: 16px; font-weight: 700;
  color: #f1f5f9; margin-bottom: 10px;
}
.why-card p {
  font-size: 13.5px; color: #94a3b8;
  line-height: 1.7;
}
@media (max-width: 1024px) { .why-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 600px) { .why-grid { grid-template-columns: 1fr; } .why-card { padding: 28px 22px; } }
</style>
